import MojitoCore from 'mojito/core';
import SingleBetsListImpl from './single-bets-list.js';
import PropTypes from 'prop-types';

/**
 * @class SingleBetList
 * @memberof Mojito.Modules.Betslip.BetslipView
 */

/**
 * SingleBetList prop types.
 *
 * @property {Mojito.Services.Betslip.types.STAKE_GROUP_NAME} activeStakeGroup - Stake group which is active.
 * @property {Mojito.Services.Betslip.types.Betslip} [betslip = {}] - Betslip.
 * @property {boolean} [highlightEnabled = false] - Flag to indicate if related bets should be highlighted.
 * @property {boolean} [bankersEnabled = true] - Flag to indicate if bankers is enabled.
 * @property {boolean} [stakingEnabled = true] - Flag to indicate if staking is enabled.
 * @property {Mojito.Services.Betslip.types.BETSLIP_STATUS} [betslipStatus] - Betslip status.
 * @property {boolean} [hasPendingBonus = false] - Set to true if some bonus requests are pending (so bonuses info will be inactive).
 * @property {boolean} [forceEWLabelsToShow = false] - Flag to indicate if EW labels should be shown.
 * @property {string} [class] - Class name assigned to the root element.
 */
const propTypes = {
    activeStakeGroup: PropTypes.string.isRequired,
    betslip: PropTypes.object,
    highlightEnabled: PropTypes.bool,
    bankersEnabled: PropTypes.bool,
    stakingEnabled: PropTypes.bool,
    betslipStatus: PropTypes.string,
    hasPendingBonus: PropTypes.bool,
    forceEWLabelsToShow: PropTypes.bool,
    class: PropTypes.string,
};

const defaultProps = {
    betslip: {},
    bankersEnabled: true,
    highlightEnabled: false,
    stakingEnabled: true,
    hasPendingBonus: false,
    forceEWLabelsToShow: false,
};

export default MojitoCore.Presentation.UIView(
    'SingleBetsList',
    SingleBetsListImpl,
    propTypes,
    defaultProps
);
